import Vue from 'vue';
import VueRouter from 'vue-router';
import { routes } from './routes';
import { middlewareBefore, middlewareAfter } from './middleware';

Vue.use(VueRouter);

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  mode: 'history',
});

router.beforeEach(middlewareBefore);
router.afterEach(middlewareAfter);

export default router;
